export default function Billing() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Billing
            </div>
            <div className="page-sub" id="page-sub">
              Monthly bills
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="stat-grid mb16">
            <div className="stat-card">
              <div className="stat-icon">🧾</div>
              <div className="stat-label">Total Bills</div>
              <div className="stat-value">3</div>
              <div className="stat-delta delta-neu">This period</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">Paid</div>
              <div className="stat-value">1</div>
              <div className="stat-delta delta-up">Collected</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⏰</div>
              <div className="stat-label">Due</div>
              <div className="stat-value">1</div>
              <div className="stat-delta delta-dn">Pending payment</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⏳</div>
              <div className="stat-label">Pending Reading</div>
              <div className="stat-value">1</div>
              <div className="stat-delta delta-dn">Awaiting approval</div>
            </div>
          </div>
          <div className="card mb16">
            <div className="flex-between mb12">
              <div
                className="card-title"
                style={{ margin: 0, color: "var(--amber)" }}
              >
                ⚡ Meter Reading Approvals (1 pending)
              </div>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto auto auto",
                gap: 12,
                alignItems: "center",
                padding: "12px 14px",
                background: "var(--bg-secondary)",
                borderRadius: "var(--radius-md)",
                marginBottom: 8,
                border: "0.5px solid var(--border-light)",
              }}
            >
              <div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>
                  Priya Sharma — Room 101
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    marginTop: 2,
                  }}
                >
                  Month: Apr 2025 &nbsp;·&nbsp; Reading:{" "}
                  <strong>1147 units</strong> &nbsp;·&nbsp; Prev: 1020 (Mar
                  2025) &nbsp;·&nbsp; Usage:{" "}
                  <strong>127 units × ₹8.5 = ₹1,079.5</strong>
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginTop: 2,
                  }}
                >
                  Submitted: Apr 30, 2025
                </div>
              </div>
              <span style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
                No screenshot
              </span>
              <button
                onclick="approveMeterReading(2)"
                style={{
                  background: "#0F6E56",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "6px 14px",
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                ✓ Approve
              </button>
              <button
                onclick="rejectMeterReading(2)"
                style={{
                  background: "#dc2626",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "6px 14px",
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                ✕ Reject
              </button>
            </div>
          </div>
          <div className="card">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 12,
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              <div className="card-title" style={{ margin: 0 }}>
                Monthly Bills
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                  alignItems: "center",
                }}
              >
                <select
                  id="bill-filter-tenant"
                  onchange="renderBillsTable()"
                  style={{
                    fontSize: 12,
                    padding: "5px 8px",
                    borderRadius: 6,
                    border: "0.5px solid var(--border-mid)",
                  }}
                >
                  <option value="">All Tenants</option>
                  <option value={1}>Priya Sharma</option>
                  <option value={2}>Karan Joshi</option>
                  <option value={3}>Anjali Verma</option>
                </select>
                <select
                  id="bill-filter-status"
                  onchange="renderBillsTable()"
                  style={{
                    fontSize: 12,
                    padding: "5px 8px",
                    borderRadius: 6,
                    border: "0.5px solid var(--border-mid)",
                  }}
                >
                  <option value="">All Status</option>
                  <option value="due">Due</option>
                  <option value="paid">Paid</option>
                  <option value="pending_reading">Awaiting Reading</option>
                </select>
                <select
                  id="bill-filter-type"
                  onchange="renderBillsTable()"
                  style={{
                    fontSize: 12,
                    padding: "5px 8px",
                    borderRadius: 6,
                    border: "0.5px solid var(--border-mid)",
                  }}
                >
                  <option value="">All Types</option>
                  <option value="electricity">Electricity</option>
                  <option value="water">Water</option>
                  <option value="rent">Rent</option>
                  <option value="other">Other / Adhoc</option>
                </select>
                <select
                  id="bill-filter-month"
                  onchange="renderBillsTable()"
                  style={{
                    fontSize: 12,
                    padding: "5px 8px",
                    borderRadius: 6,
                    border: "0.5px solid var(--border-mid)",
                  }}
                >
                  <option value="">All Months</option>
                  <option value="2025-04">Apr 2025</option>
                  <option value="2025-03">Mar 2025</option>
                </select>
                <button
                  className="btn btn-primary btn-sm"
                  onclick="openGenerateBillModal()"
                >
                  + Generate Adhoc Bill
                </button>
              </div>
            </div>
            <div id="bills-table-container">
              <div style={{ overflowX: "auto" }}>
                <table id="po-bills-table">
                  <thead>
                    <tr>
                      <th>Tenant</th>
                      <th>Unit</th>
                      <th>Month</th>
                      <th>Rent</th>
                      <th>Electricity</th>
                      <th>Water</th>
                      <th>Other</th>
                      <th>Total</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody id="po-bills-tbody">
                    <tr>
                      <td style={{ fontSize: 12 }}>Priya Sharma</td>
                      <td
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        Room 101
                      </td>
                      <td style={{ fontSize: 12 }}>Mar 2025</td>
                      <td style={{ fontSize: 12 }}>₹8,500</td>
                      <td style={{ fontSize: 12 }}>
                        120 u × ₹8.5 = <strong>₹1,020</strong>
                      </td>
                      <td style={{ fontSize: 12 }}>₹200</td>
                      <td style={{ fontSize: 12 }}>—</td>
                      <td style={{ fontWeight: 700, color: "var(--blue)" }}>
                        ₹9,720
                      </td>
                      <td>
                        <span className="badge badge-active">✓ Paid</span>
                      </td>
                      <td>
                        <button
                          onclick="viewBillDetail(1)"
                          className="btn btn-xs"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: 12 }}>Karan Joshi</td>
                      <td
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        Room 204
                      </td>
                      <td style={{ fontSize: 12 }}>Mar 2025</td>
                      <td style={{ fontSize: 12 }}>₹9,500</td>
                      <td style={{ fontSize: 12 }}>
                        <span style={{ color: "var(--text-tertiary)" }}>—</span>
                      </td>
                      <td style={{ fontSize: 12 }}>₹200</td>
                      <td style={{ fontSize: 12 }}>—</td>
                      <td style={{ fontWeight: 700, color: "var(--blue)" }}>
                        ₹9,700
                      </td>
                      <td>
                        <span
                          className="badge badge-due"
                          style={{ background: "#FEE2E2", color: "#991B1B" }}
                        >
                          Due
                        </span>
                      </td>
                      <td>
                        <button
                          onclick="viewBillDetail(2)"
                          className="btn btn-xs"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: 12 }}>Priya Sharma</td>
                      <td
                        style={{ fontSize: 11, color: "var(--text-secondary)" }}
                      >
                        Room 101
                      </td>
                      <td style={{ fontSize: 12 }}>Apr 2025</td>
                      <td style={{ fontSize: 12 }}>₹8,500</td>
                      <td style={{ fontSize: 12 }}>
                        <span style={{ color: "var(--text-tertiary)" }}>—</span>
                      </td>
                      <td style={{ fontSize: 12 }}>₹200</td>
                      <td style={{ fontSize: 12 }}>Maintenance: ₹500</td>
                      <td style={{ fontWeight: 700, color: "var(--blue)" }}>
                        ₹9,200
                      </td>
                      <td>
                        <span className="badge badge-gray">
                          Awaiting Reading
                        </span>
                      </td>
                      <td>—</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
